import React from 'react'
import './Floatingdiv.css';


 export default function Floatingdiv({Image,text1,text2}) {
  return (
    <div className="floatingdiv">

        <span><img src={Image} alt=''/></span>
        <span>
        {text1}
        <br/>
        {text2}
        </span>
        </div>
        
       
    
  )
}


    


